var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"screen"},[_c('img',{staticClass:"logo",attrs:{"src":require("../assets/logo.png"),"alt":"Chase"}}),_c('button',{on:{"click":_vm.getRequestToken}},[_vm._v("Connect to Pocket")])])}
var staticRenderFns = []

export { render, staticRenderFns }